import dayjs, { Dayjs } from 'dayjs';
import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DevicesResponse } from '@pages/booking/types';
import {
    selectDevicesRequiredForScheme,
    selectGetDevicesRequiredForSchemeStatus,
} from '@pages/schemes/store/selectors';
import { clearLocalBookings, clearSelectedBookings } from '@pages/booking/store';
import { Box } from '@mui/material';
import { BookingCalendar } from '@pages/booking';

interface DeployBookingStepProps {
    standExpireDateTime: Dayjs;
    isCurrentStep: boolean;
}

const DeployBookingStep: FC<DeployBookingStepProps> = ({ isCurrentStep, standExpireDateTime }) => {
    const dispatch = useDispatch();
    const devicesRequiredForScheme: DevicesResponse = useSelector(selectDevicesRequiredForScheme);
    const getDevicesRequiredForSchemeStatus = useSelector(selectGetDevicesRequiredForSchemeStatus);

    const bookingRequiredPeriod = useMemo<[Date, Date]>(() => {
        const currentHourDate = dayjs().minute(0).second(0).millisecond(0).toDate();
        const standExpireDate = standExpireDateTime.toDate();

        return [currentHourDate, standExpireDate];
    }, [standExpireDateTime]);

    useEffect(() => {
        dispatch(clearSelectedBookings());
    }, [dispatch, standExpireDateTime]);

    useEffect(() => {
        return () => {
            dispatch(clearLocalBookings());
        };
    }, [dispatch]);

    return (
        <Box
            sx={{
                display: isCurrentStep ? 'flex' : 'none',
                flexDirection: 'column',
                gap: 2,
                pt: 2,
                height: 720,
                width: 1280,
            }}
        >
            <BookingCalendar
                devicesExternal={devicesRequiredForScheme}
                getDevicesStatusExternal={getDevicesRequiredForSchemeStatus}
                config={{
                    selectMode: true,
                    bookingRequiredPeriod: bookingRequiredPeriod,
                }}
            />
        </Box>
    );
};

export default DeployBookingStep;
